
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const navLinks = [
    { path: '/', label: 'HOME' },
    { path: '/about', label: 'ABOUT' },
    { path: '/information', label: 'INFORMATION' },
    { path: '/recruit', label: 'RECRUIT' },
    { path: '/style', label: 'STYLE' },
    { path: '/contact', label: 'CONTACT' },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="text-xl sm:text-2xl font-bold tracking-wider" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            <span className={`transition-colors ${isScrolled ? 'text-sub' : 'text-white'}`}>おかやま美容室</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium tracking-wider transition-colors whitespace-nowrap ${
                  isScrolled ? 'text-sub/70 hover:text-sub' : 'text-white hover:text-gray-200'
                } ${location.pathname === link.path ? 'border-b-2 border-current' : ''}`}
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${isScrolled ? 'text-sub' : 'text-white'}`}
            aria-label="メニュー"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <nav className="flex flex-col py-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-6 py-3 text-sm font-medium tracking-wider text-sub/70 hover:bg-accent/30 transition-colors whitespace-nowrap ${
                  location.pathname === link.path ? 'bg-accent/50 border-l-4 border-primary' : ''
                }`}
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
